import { getAnalytics, logEvent } from "firebase/analytics";

const analytics = getAnalytics();

export const AnalyticsEvent = {

  // navigation
  VIEW_COMPANY: "view_company", // done
  VIEW_VACANCY: "view_vacancy", // done
  VIEW_EVENT: "view_event",  // done
  VIEW_USER: "view_user", // done

  // interactions
  FOLLOW_COMPANY: "follow_company", // done
  SEND_USER_FRIEND_REQUEST: "send_user_friend_request", // done
  SEND_USER_COVER_AI_LETTER: "send_user_cover_ai_letter", // done

  // vacancies
  APPLY_VACANCY: "apply_vacancy", // done
  SAVE_VACANCY_TO_FAVORITE: "save_vacancy_to_favorite",

  // events
  OPEN_EVENT_LINK: "open_event_link", // done
  CREATE_EVENT: "create_event", // done

  // search
  SEARCH_USER: "search_user",
  SEARCH_VACANCY: "search_vacancy", // done

  // common
  INIT_START_APP: "init_start_app", 
  OPEN_PROFILE: "open_profile"

};

export class AnalyticsService {

  static log(event, params = {}) {
    logEvent(analytics, event, params);
  }

}